export default __webpack_public_path__ + "static/lb-06-505b08292db60d67d0e137afe47cd80c.webp";